// AI工作台基础翻译

export const workbench = {
    title: 'AI工作台',
    subtitle: '專業的AI驅動圖像生成和編輯工作空間',
    workbenchTitle: 'AI圖片工具工作台',
    workbenchSubtitle: '探索強大的AI圖片處理工具，讓您的創意無限延伸',
    tryNow: '立即體驗',
    moreComing: '更多工具即將推出',
    moreComingDescription: '我們正在不斷開發新的AI圖片處理工具，敬請期待！',
    imageToImage: '圖像轉圖像',
    imageToImageDesc: '使用AI驅動的編輯和增強功能轉換現有圖像。',
    imageToImageDescription: '上傳參考圖像並使用AI驅動的編輯進行轉換。非常適合風格轉換、增強和創意修改。',
    textToImage: '文字轉圖像',
    textToImageDesc: '使用先進的AI從文字描述生成令人驚嘆的圖像。',
    textToImageDescription: '使用先進的AI技術從文字描述生成高質量圖像。只需描述您想看到的內容，我們的AI將為您創建令人驚嘆的視覺效果。',
    textToImageMode: '文字轉圖像模式',
    size: '尺寸',
    sizeDescriptions: {
      squareLarge: '正方形 (1:1)',
      portrait23: '直式 (2:3)',
      landscape32: '橫式 (3:2)',
      portrait34: '直式 (3:4)',
      landscape43: '橫式 (4:3)',
      portrait45: '直式 (4:5)',
      landscape54: '橫式 (5:4)',
      portrait916: '直式 (9:16)',
      landscape169: '橫式 (16:9)',
      ultrawide219: '超寬螢幕 (21:9)'
    }
  };
